import { c as _c } from "react/compiler-runtime";
import { XtdhMetricsSection } from "./subcomponents/XtdhMetricsSection";
import { XtdhReceivingSection } from "./subcomponents/XtdhReceivingSection";
import { getXtdhStatsSectionClassName } from "./utils/getXtdhStatsSectionClassName";
import type { XtdhStatsProps } from "./types";
export function XtdhStats(t0) {
  const $ = _c(10);
  const {
    metrics,
    receiving,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = getXtdhStatsSectionClassName(className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sectionClassName = t1;
  let t2;
  if ($[2] !== metrics) {
    t2 = <XtdhMetricsSection {...metrics} />;
    $[2] = metrics;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== receiving) {
    t3 = receiving ? <XtdhReceivingSection {...receiving} /> : null;
    $[4] = receiving;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== sectionClassName || $[7] !== t2 || $[8] !== t3) {
    t4 = <section className={sectionClassName} aria-label="xTDH Statistics">{t2}{t3}</section>;
    $[6] = sectionClassName;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}